import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { object, string } from 'yup';
import {
  Formik,
  Form,
} from 'formik';
import axios from 'axios';

import FormGroup from '~/commons/components/FormGroup.jsx';
import { useAlert } from '../../../commons/components/alert/index.jsx';

const FormLogin = ({
  router = true,
}) => {
  const [persist, setPersist] = useState(true);
  const [showPwd, setShowPwd] = React.useState(false);

  const showAlert = useAlert();

  return (
    <>
      <Formik
        validationSchema={object().shape({
          username: string()
            .trim()
            .lowercase()
            .required('Required'),
          ...showPwd ? {
            password: string()
              .required('Required'),
          } : {}
        })}
        initialValues={{
          username: '',
          password: '',
        }}
        onSubmit={async (values) => {
          try {
            if (showPwd) {
              const res = await axios.post('/api/core/auth', {
                ...values,
                web: 1,
                portal: 1,
                persist,
              });
              if (res.status === 200) {
                window.location.replace('/portal');
              } else {
                showAlert('danger', 'Unknown error', 2000);
              }
            } else {
              const res = await axios.post('/api/core/auth/require-set-password', {
                username: values.username,
              });

              if (res.status === 200) {
                if (res.data.isRequired) {
                  window.location.replace(`/portal/auth/activate?email=${encodeURIComponent(values.username)}`);
                } else {
                  setShowPwd(true);
                }
              } else {
                showAlert('danger', 'Unknown error', 2000);
              }
            }

          } catch (e) {
            if (e.response?.status === 400) {
              showAlert('danger', e.response.data, 2000);
            } else {
              showAlert('danger', e, 2000);
            }
          }
        }}
      >
        <Form>
          <FormGroup
            name="username"
            label={null}
            placeholder="Email / Username"
          />
          {showPwd && <FormGroup
            name="password"
            type="password"
            label={null}
            placeholder="Password"
          />}
          <div className="row mb-3">
            <div className="col">
              <div className="form-check form-control-sm">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="persist"
                  checked={persist}
                  onChange={() => setPersist(!persist)}
                />
                <label
                  className="form-check-label"
                  htmlFor="persist"
                >
                  Remember me
                </label>
              </div>
            </div>
            <div className="col-auto">
              {router ? (
                <Link to="/portal/auth/pwd-recovery">
                  <small>Forgot password?</small>
                </Link>
              ) : (
                <a href="/portal/auth/pwd-recovery">
                  <small>Forgot password?</small>
                </a>
              )}
            </div>
          </div>
          <div className="form-group text-right">
            <button className="btn btn-primary btn-block">
              Next
            </button>
          </div>
        </Form>
      </Formik>
    </>
  );
};

export default FormLogin;
